import { SliderModal, Text, Button, Switch, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, TextArea } from 'native-base';
import React from 'react';
import { ActivityIndicator } from 'react-native';

import { Header } from './components/Header';

import { UnlockCustomerTypes } from '.';
export const ContainerMobile: React.FC<UnlockCustomerTypes.Props> = ({
  chosenShippingType,
  handleSwitchChange,
  handleTextAreaChange,
  selectedValues,
  textAreaInput,
  sendUnlockCustomer,
  unlockCustomerSendState,
  goBack,
}) => {
  return (
    <SliderModal dismissWhenClickOutside={false} width={1}>
      <VStack
        flex={1}
        alignSelf={'space-between'}
        justifyContent={'space-between'}
        p={Spacing['inline.xxxs']}>
        <Box>
          <Header status="lock" />
          <VStack
            backgroundColor={Color['neutral.white']}
            marginTop={Spacing['inline.sm']}
            shadow={4}
            borderRadius={Spacing['inline.nano']}
            px={Spacing['inline.xxs']}
            paddingY={Spacing['inset.sm']}
            space={Spacing['stack.xxs']}>
            <VStack>
              <Text
                paddingBottom={Spacing['inset.nano']}
                fontWeight={Typography['fontweight.semibold']}
                fontSize={Typography['fontsize.md']}>
                Canal de envio
              </Text>

              <HStack
                paddingBottom={Spacing['inset.xs']}
                justifyContent={'space-between'}
                alignItems="center">
                <Text fontSize={Typography['fontsize.md']}>E-mail</Text>
                <Switch
                  onToggle={() => handleSwitchChange!('email')}
                  isChecked={selectedValues!.includes('email')}
                />
              </HStack>
            </VStack>

            <VStack>
              <Text
                marginBottom={Spacing['inset.xs']}
                paddingY={Spacing['inset.nano']}
                color={['neutral.dark']}
                fontSize={Typography['fontsize.md']}
                fontWeight={Typography['fontweight.semibold']}>
                Informação adicional{' '}
                <Text
                  fontSize={Typography['fontsize.xs']}
                  color={['neutral.dark']}
                  fontWeight={Typography['fontweight.regular']}>
                  (opcional)
                </Text>
              </Text>

              <Box height={137}>
                <TextArea
                  flex={1}
                  borderRadius={Spacing['inline.nano']}
                  backgroundColor={'#F9F9F9'}
                  borderColor={'transparent'}
                  _focus={{
                    backgroundColor: 'transparent',
                    borderColor: Color['brand.primary.principal'],
                    borderWidth: 1,
                  }}
                  _hover={{ borderColor: Color['brand.primary.principal'] }}
                  caretHidden
                  value={textAreaInput}
                  placeholder="Adicione mais detalhes à solicitação."
                  autoCompleteType={'off'}
                  onChangeText={handleTextAreaChange}
                />
              </Box>

              <Text
                fontWeight={Typography['fontweight.regular']}
                fontSize={Typography['fontsize.xs']}
                paddingTop={Spacing['inset.md']}
                color={['neutral.dark']}>
                Será enviado para cliente um link de uso único e expirará após a primeira tentativa
                de acesso. Após a confirmação, o contato será automaticamente removido desta lista.
              </Text>
            </VStack>
          </VStack>
        </Box>

        <HStack
          py={Spacing['inline.xxxs']}
          width={'100%'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <Button
            width={'41%'}
            maxWidth={160}
            backgroundColor="transparent"
            size="lg"
            onPress={goBack}>
            <Text
              fontWeight={Typography['fontweight.semibold']}
              fontSize={Typography['fontsize.md']}
              color={['brand.primary.darkest']}>
              CANCELAR
            </Text>
          </Button>
          <Button
            width={'41%'}
            maxWidth={160}
            onPress={() => sendUnlockCustomer()}
            isDisabled={!chosenShippingType || unlockCustomerSendState.isLoading}
            backgroundColor={Color['feedback.success.default']}
            size="lg">
            {unlockCustomerSendState.isLoading ? (
              <ActivityIndicator size={'small'} color={Color['brand.primary.principal']} />
            ) : (
              <Text
                fontWeight={Typography['fontweight.semibold']}
                fontSize={Typography['fontsize.md']}
                color={['neutral.white']}>
                CONFIRMAR
              </Text>
            )}
          </Button>
        </HStack>
      </VStack>
    </SliderModal>
  );
};
